/* istanbul ignore file */
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';

export const ON_CLICK_INSIGHT = 'ON_CLICK_INSIGHT';
export const CLEAR_SELECTED_INSIGHT = 'CLEAR_SELECTED_INSIGHT';
export const ON_COMPONENT_LOADING = 'ON_COMPONENT_LOADING';

export const clearSelectedInsight = () => ({
  type: CLEAR_SELECTED_INSIGHT
});

export const onClickInsight = insightKey => {
  TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
    page: TRACKING.PAGES.PROJECT_PROGRESSION,
    click_type: TRACKING.CLICK.PROJECT_PROGRESSION.INSIGHTS.ON_SELECT_INSIGHT,
    value: insightKey
  });
  return {
    type: ON_CLICK_INSIGHT,
    payload: insightKey
  };
};

export const onRemoveInsightFilter = () => ({
  type: ON_CLICK_INSIGHT,
  payload: null
});

export const onComponentLoading = (compKey, isLoading) => ({
  type: ON_COMPONENT_LOADING,
  payload: {
    compKey,
    isLoading
  }
});
